import mapboxgl from 'mapbox-gl'
import translate from '../utils/translations'
import axios from 'axios'

export default {
  name: 'dealers',

  ui: {
    stickyButton: '[js-dealers-sticky]',
    map: '[js-dealers-map]',
  },

  componentDidMount() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiZGV2LWJ5IiwiYSI6ImNscGI5enZnZDBmbm0yaWxzN3dvN3lhZTcifQ.Lf4iBlAkEco-aqSIlidlxw'

    const formData = new FormData()
    formData.append('nonce', this.props.nonce)
    formData.append('action', this.props.action)

    axios.post(this.props.route, formData)
      .then(response => {
        this.markers = response.data.data
        this.initMap()
      })
      .catch(e => {
        console.log('error getting dealers')
      })
  },

  initMap() {
    this.map = new mapboxgl.Map({
      container: 'dealers-map', // container ID
      center: [2.45, 46],
      style: this.props.site === 'sailing' ? 'mapbox://styles/dev-by/clpbasnna007t01pj50cx866n' : 'mapbox://styles/dev-by/clpbac8km007r01pkhdrq5jcx', // style URL
      zoom: 2, // starting zoom
    })

    this.map.on('load', () => {
      const labels = ['country-label', 'state-label', 'settlement-label', 'settlement-subdivision-label', 'airport-label', 'poi-label', 'water-point-label', 'water-line-label', 'natural-point-label', 'natural-line-label', 'waterway-label', 'road-label']

      labels.forEach(label => {
        this.map.setLayoutProperty(label, 'text-field', ['get', `name_${document.documentElement.lang}`])
      })
    })

    this.map.loadImage(
      `/wp-content/themes/fountaine-pajot/assets/images/map/${this.props.site === 'motor' ? 'pin-xdark-blue' : 'pin-coral'}.png`,
      (error, image) => {
        if (error) throw error

        // Add the image to the map style.
        this.map.addImage('pin', image)
      },
    )

    this.map.loadImage(
      `/wp-content/themes/fountaine-pajot/assets/images/map/${this.props.site === 'motor' ? 'pin-blue' : 'pin-xdark-blue'}.png`,
      (error, image) => {
        if (error) throw error

        // Add the image to the map style.
        this.map.addImage('pinActive', image)
      },
    )

    this.map.on('load', () => {
      this.map.addSource('markersDatas', {
        type: 'geojson',
        generateId: true, // This ensures that all features have unique IDs
        data: this.markers,
        cluster: true,
        clusterRadius: 80,
      })

      this.map.addLayer({
        id: 'unclustered-points',
        type: 'symbol',
        source: 'markersDatas',
        filter: ['!has', 'point_count'],
        layout: {
          'icon-image': 'pin',
          'icon-size': 0.45,
        },
      })

      this.map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'markersDatas',
        paint: {
          'circle-color': this.props.site === 'motor' ? '#002432' : '#E9473F',
          'circle-radius': 18,
        },
        filter: ['has', 'point_count'],
      })

      // Add a layer for the clusters' count labels
      this.map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'markersDatas',
        layout: {
          'text-field': '{point_count}',
          'text-font': [
            'DIN Offc Pro Medium',
            'Arial Unicode MS Bold',
          ],
          'text-size': 12,
        },
        paint: {
          'text-color': '#ffffff',
        },
      })

      // inspect a cluster on click
      this.map.on('click', 'clusters', (e) => {
        const features = this.map.queryRenderedFeatures(e.point, {
          layers: ['clusters']
        });
        const clusterId = features[0].properties.cluster_id;
        this.map.getSource('markersDatas').getClusterExpansionZoom(
          clusterId,
          (err, zoom) => {
            if (err) return;
            this.map.easeTo({
              center: features[0].geometry.coordinates,
              zoom: zoom
            });
          }
        );
      });
      this.map.on('mouseenter', 'unclustered-points', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'unclustered-points', () => {
        this.map.getCanvas().style.cursor = '';
      });
      this.map.on('mouseenter', 'clusters', () => {
        this.map.getCanvas().style.cursor = 'pointer';
      });
      this.map.on('mouseleave', 'clusters', () => {
        this.map.getCanvas().style.cursor = '';
      });
    })

    this.map.on('click', (e) => {
      const features = this.map.queryRenderedFeatures(e.point, { layers: ['unclustered-points'] })

      if (!features.length) {
        return
      }

      const feature = features[0]

      // set marker active image on click
      this.map.setLayoutProperty('unclustered-points', 'icon-image',
        [
          'match',
          ['id'], // get the feature id (make sure your data has an id set or use generateIds for GeoJSON sources
          feature.id, 'pinActive', // image when id is the clicked feature id
          'pin', // default
        ],
      )

      new mapboxgl.Popup()
        .setLngLat(feature.geometry.coordinates)
        .setHTML(`
          <div class="flex flex-col justify-between">
            <div>
              <img class="w-full" src="${this.props.site === 'motor' ? '/wp-content/themes/fountaine-pajot/assets/images/map/Dealership-boat-fountaine-pajot-motor-yachts.jpg' : '/wp-content/themes/fountaine-pajot/assets/images/map/Dealership-boat-fountaine-pajot-catamarans.jpg'}" alt="" />
              <p class="map__popup-title">${feature.properties.title}</p>
              <p class="map__popup-desc">${feature.properties.description}</p>
            </div>
            <a href="${this.props.dealerForm}" class="cta"><span>${translate('CONTACT_DEALER')}</span></a>
          </div>
        `).addTo(this.map)
    })
  },
}
